import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ROUTES } from 'src/navigation';

const Delivery = () => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');

  return (
    <div className="stack">
      <h2>{tHelpAndSupport('commonQuestions.GoalAchievement.Delivery')}</h2>
      <p>{tHelpAndSupport('commonQuestions.GoalAchievement.Delivery.Deadline')}</p>
      <p>{tHelpAndSupport('commonQuestions.GoalAchievement.Delivery.Text1')}</p>
      <p>{tHelpAndSupport('commonQuestions.GoalAchievement.Delivery.Text2')}</p>
      <p>{tHelpAndSupport('commonQuestions.GoalAchievement.Delivery.Text3')}</p>
      <Link className="display--block" to={ROUTES.SIVA.REPORTING.GOALS.BASE}>
        {tHelpAndSupport('commonQuestions.GoalAchievement.Delivery.Link')}
      </Link>
    </div>
  );
};

export default Delivery;
